
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getCatalogData","createTodayItemData"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "ad32e09ce774d3833dfd.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			